import React, { useMemo, useState } from "react";
import Header from "../../../../src/components/Header/Header";
import { Tab, Tabs } from "@material-ui/core";
import { useHistory } from 'react-router'
import CreateInterfacePermission from "./CreateInterfacePermission";
import CreateInterfaceRole from "./CreateInterfaceRole";
import AssignInterfaceRole from "./AssignInterfaceRole";
import AssignInterfacePermission from "./AssignInterfacePermission";
import UpdateUserStatus from "./UpdateUserStatus";
import DeleteRolePermission from "./DeleteRolePermission";
import "./grbreport.scss";
import Box from '@mui/material/Box';
import { isPermission } from "../../../_helpers/commonAPI";
import AuthorizedMessagePage from "../../../components/AuthorizedMessagePage";

const Reports = () => {
    let history = useHistory()
    const navigateToPlace = (navTo) => {
        history.push(navTo)
    }
    const boxClass = {
        cursor: 'pointer',
    }
    return (<>
        <div className='row mt-3 mb-3'
            style={{ padding: "10px" }} >
            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3'>
                <div class="card">
                    <div class="card-body text-center" onClick={() => navigateToPlace('/LoginAuditReport')} style={boxClass}>
                    User Login Audit Report
                    </div>
                </div>
            </div>

            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3'>
                <div class="card">
                    <div class="card-body text-center" onClick={() => navigateToPlace('/UserRoleChange')} style={boxClass}>
                    User Role Audit Report
                    </div>
                </div>
            </div>

            <div className='col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3'>
                <div class="card">
                    <div class="card-body text-center" onClick={() => navigateToPlace('/RolePermissionChange')} style={boxClass}>
                    Role Permissions Audit Report
                    </div>
                </div>
            </div>
        </div>
    </>)
}

const Interfaces = () => {
    const [interfaceTab, setInterfaceTab] = React.useState(0);
    const userID = JSON.parse(localStorage.getItem("userData")).userId;
    const handleChange = async (event, newValue) => {
        setInterfaceTab(newValue);
    };

    return (
        <div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={interfaceTab} onChange={handleChange}>
                    <Tab label="Create Permission" wrapped={false} style={{ maxWidth: "295px" }} />
                    <Tab label="Create Role" wrapped={false} style={{ maxWidth: "312px" }} />
                    <Tab label="Assign Role" wrapped={false} style={{ maxWidth: "312px" }} />
                    <Tab label="Assign Permissions" wrapped={false} style={{ maxWidth: "312px" }} />
                    <Tab label="Update User Status" wrapped={false} style={{ maxWidth: "312px" }} />
                    <Tab label="Delete Role/permission" wrapped={false} style={{ maxWidth: "312px" }} />
                </Tabs>
            </Box>
            {interfaceTab === 0 && <CreateInterfacePermission userID={userID} />}
            {interfaceTab === 1 && <CreateInterfaceRole userID={userID} />}
            {interfaceTab === 2 && <AssignInterfaceRole userID={userID} />}
            {interfaceTab === 3 && <AssignInterfacePermission userID={userID} />}
            {interfaceTab === 4 && <UpdateUserStatus userID={userID} />}
            {interfaceTab === 5 && <DeleteRolePermission userID={userID} />}
        </div>
    )
}

const GREReport = () => {
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [isAllowAccess, setIsAllowAccess] = useState(false)
    const handleChange = async (event, newValue) => {
        setSelectedTab(newValue);
    };

    useMemo(async()=>{
        const isAllow = await isPermission("GRCReports-Reports-view")
        setIsAllowAccess(isAllow)
    },[])

    return (
        <div className="content-wrapper">
            <Header title="GRC Reports" />
            <div className="row ipad_css ">
                <div className="mainScroll">
                    {isAllowAccess ?
                        <div className="col-12 mt-2">
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={selectedTab} onChange={handleChange}>
                                    <Tab label="Reports" wrapped={false} style={{ maxWidth: "295px" }} />
                                    <Tab label="Interfaces" wrapped={false} style={{ maxWidth: "312px" }} />
                                </Tabs>
                            </Box>
                            {selectedTab === 0 && <Reports />}
                            {selectedTab === 1 && <Interfaces />}
                        </div>
                        :
                        <AuthorizedMessagePage />
                    }
                </div>
            </div>
        </div>
    )
}

export default GREReport